import { handleApi } from "..";
import {
  ADD_MANUAL_AUTHORIZATION,
  GET_MANUAL_AUTHORIZATION,
  DELETE_MANUAL_AUTHORIZATION,
} from "../../constants/api_constants";

export const addManualAuthorizationApi = async (values) =>
  handleApi("post", ADD_MANUAL_AUTHORIZATION, values);

export const getManualAuthorizationApi = async (id) =>
  handleApi("get", `${GET_MANUAL_AUTHORIZATION}/${id}`);

export const deleteManualAuthorizationApi = async (id) =>
  handleApi("delete", `${DELETE_MANUAL_AUTHORIZATION}/${id}`);
